// src/admin/components/buildings/BuildingSelectionModal.jsx
import React from 'react';
import { useTranslation } from 'react-i18next';
import { 
  RiBuildingLine,
  RiCloseLine,
  RiFileAddLine
} from 'react-icons/ri';
import { useTheme } from '../../../contexts/ThemeContext';

const BuildingSelectionModal = ({ buildings, onSelect, onCancel }) => {
  const { t } = useTranslation();
  const { isDarkMode } = useTheme();

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
      <div className={`${isDarkMode ? 'bg-zinc-900 border-gray-700' : 'bg-white border-gray-200'} rounded-xl border shadow-lg max-w-2xl w-full max-h-[80vh] overflow-hidden`}>
        <div className={`p-4 ${isDarkMode ? 'border-b border-gray-700' : 'border-b border-gray-200'} flex justify-between items-center`}>
          <h3 className={`text-lg font-semibold ${isDarkMode ? 'text-white' : 'text-gray-900'} flex items-center`}>
            <RiFileAddLine className="mr-2 text-red-500" />
            {t('select_building_for_bulk_creation') || 'Select Building for Bulk Apartment Creation'}
          </h3>
          <button
            onClick={onCancel}
            className={`${isDarkMode ? 'text-zinc-400 hover:text-gray-300' : 'text-gray-500 hover:text-gray-700'}`}
          >
            <RiCloseLine size={24} />
          </button>
        </div>
        
        <div className="p-4 max-h-96 overflow-y-auto">
          <div className="grid grid-cols-1 gap-3">
            {buildings.map((building) => (
              <button
                key={building.id}
                onClick={() => onSelect(building.id)}
                className={`p-4 rounded-lg border ${
                  isDarkMode 
                    ? 'border-gray-600 bg-gray-750 hover:bg-zinc-800 text-white' 
                    : 'border-gray-200 bg-gray-50 hover:bg-gray-100 text-gray-900'
                } text-start transition-colors duration-200`}
              >
                <div className="flex items-center justify-between">
                  <div className="flex items-center">
                    <div className={`p-2 rounded-lg ${
                      isDarkMode ? 'bg-red-900 bg-opacity-20 text-red-400' : 'bg-zinc-100 text-red-600'
                    }`}>
                      <RiBuildingLine size={20} />
                    </div>
                    <div className="ml-3">
                      <h4 className={`font-medium ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
                        {building.name}
                      </h4>
                      <p className={`text-sm ${isDarkMode ? 'text-zinc-400' : 'text-gray-500'}`}>
                        {building.address}
                      </p>
                      <p className={`text-xs ${isDarkMode ? 'text-gray-500' : 'text-zinc-400'}`}>
                        {building.totalFloors} floors • {building.totalApartments || 0} apartments
                      </p>
                    </div>
                  </div>
                  <RiFileAddLine className={`${isDarkMode ? 'text-green-400' : 'text-green-600'}`} size={20} />
                </div>
              </button>
            ))}
          </div>
        </div>
        
        <div className={`p-4 ${isDarkMode ? 'border-t border-gray-700' : 'border-t border-gray-200'} flex justify-end`}>
          <button
            onClick={onCancel}
            className={`px-4 py-2 rounded-lg ${
              isDarkMode ? 'bg-zinc-800 text-gray-300 hover:bg-gray-600' : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
            }`}
          >
            {t('cancel') || 'Cancel'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default BuildingSelectionModal;